import React from 'react'
import Typography from '@material-ui/core/Typography'
import classnames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Boxes from '../../boxes'
import styles from './styles'

const Boxer = withStyles(styles)(props => {
  const { add, minus, selected, classes, contents, type, inc, count, key } = props

  const data = contents.filter(x => x.type === type)[count[type]].content
  inc(type)

  return (
    <div className={classes.page} key={key}>
      <div className={classes.contents}>
        <div className={classes.boxer}>
          <div className={classnames(classes.layout, classes.margins)}>
            {data.primary.step && (
              <Typography variant="title">{data.primary.step.text}</Typography>
            )}
            <Typography variant="headline">
              {data.primary.title.text}
            </Typography>
            <Typography variant="subheading">
              {data.primary.subtitle.text}
            </Typography>
          </div>
        </div>
        <div className={classes.boxerContents}>
          <Boxes data={data} selected={selected} add={add} minus={minus} />
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(Boxer)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/boxer.js